import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import React from 'react';

export default function PrimaryButton(props: LoadingButtonProps) {
  return (
    <LoadingButton
      color="buttonsTonalInverse"
      variant="contained"
      className="click-outside-exception"
      {...props}
    ></LoadingButton>
  );
}
